// generated from 02_通道表.json
export const channelsData = {
  "schema_version": 2,
  "total_columns": 78,
  "source_of_truth": "WFA-2026-1001/Recording/ChannelMap.cs::BuildV2()",
  "unit_rule": "模拟量统一换算: 值 = (raw_A * 1e6 - 4000) / 16000 * Range + Offset，保留 Decimals 位",
  "note": "温度由 NI MAX 直出摄氏度，代码不换算；freq_* 存真实 Hz（原始 Hz*100 乘 0.01）",
  "columns": [
    {
      "section": "元信息",
      "key": "seq",
      "hardware": "-",
      "name": "记录序号",
      "quantity": "序号",
      "unit": "-",
      "range": 1,
      "offset": 0,
      "decimals": 0,
      "source": "Meta",
      "scale": "Linear",
      "enabled": true,
      "note": "会话内单调递增，从 1 开始。丢帧检测与 CSV/SQLite 对齐靠它"
    },
    {
      "section": "元信息",
      "key": "ts",
      "hardware": "-",
      "name": "采集时间",
      "quantity": "时间",
      "unit": "ISO8601",
      "range": 1,
      "offset": 0,
      "decimals": 0,
      "source": "Meta",
      "scale": "Linear",
      "enabled": true,
      "note": "本地时间带时区偏移，如 2026-10-20T14:03:22+08:00"
    },
    {
      "section": "元信息",
      "key": "op",
      "hardware": "-",
      "name": "操作记录",
      "quantity": "操作码",
      "unit": "-",
      "range": 1,
      "offset": 0,
      "decimals": 0,
      "source": "Meta",
      "scale": "Linear",
      "enabled": true,
      "note": "本秒内操作码，多个用、分隔；空=无操作。码表见 OperationCodes"
    },
    {
      "section": "温度(48)",
      "key": "T1_0",
      "hardware": "T1-0",
      "name": "通空气管道测点",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "进气"
    },
    {
      "section": "温度(48)",
      "key": "T1_1",
      "hardware": "T1-1",
      "name": "混合器温度",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "进气"
    },
    {
      "section": "温度(48)",
      "key": "T1_2",
      "hardware": "T1-2",
      "name": "进吸收塔前温度",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "进气；=烟气加热恒温控制反馈点 GasHeat_now"
    },
    {
      "section": "温度(48)",
      "key": "T1_3",
      "hardware": "T1-3",
      "name": "吸收塔富液出口",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "循环"
    },
    {
      "section": "温度(48)",
      "key": "T1_4",
      "hardware": "T1-4",
      "name": "回热器富液进口",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "循环"
    },
    {
      "section": "温度(48)",
      "key": "T1_5",
      "hardware": "T1-5",
      "name": "回热器富液出口",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "循环"
    },
    {
      "section": "温度(48)",
      "key": "T1_6",
      "hardware": "T1-6",
      "name": "解吸塔贫液出口",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "循环"
    },
    {
      "section": "温度(48)",
      "key": "T1_7",
      "hardware": "T1-7",
      "name": "回热器贫液进口",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "循环"
    },
    {
      "section": "温度(48)",
      "key": "T1_8",
      "hardware": "T1-8",
      "name": "回热器贫液出口",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "循环"
    },
    {
      "section": "温度(48)",
      "key": "T1_9",
      "hardware": "T1-9",
      "name": "冷却器1贫液出口",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "循环"
    },
    {
      "section": "温度(48)",
      "key": "T1_10",
      "hardware": "T1-10",
      "name": "吸收塔冷凝器废气进口",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "循环"
    },
    {
      "section": "温度(48)",
      "key": "T1_11",
      "hardware": "T1-11",
      "name": "吸收塔冷凝器废气出口",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "循环"
    },
    {
      "section": "温度(48)",
      "key": "T1_12",
      "hardware": "T1-12",
      "name": "解吸塔冷凝器CO2进口",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "循环"
    },
    {
      "section": "温度(48)",
      "key": "T1_13",
      "hardware": "T1-13",
      "name": "解吸塔冷凝器CO2出口",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "循环"
    },
    {
      "section": "温度(48)",
      "key": "T1_14",
      "hardware": "T1-14",
      "name": "压缩机进口",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": false,
      "note": "冷凝；压缩机子系统未启用，可能未接或接错"
    },
    {
      "section": "温度(48)",
      "key": "T1_15",
      "hardware": "T1-15",
      "name": "压缩机出口",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": false,
      "note": "冷凝；压缩机子系统未启用，可能未接或接错"
    },
    {
      "section": "温度(48)",
      "key": "T2_0",
      "hardware": "T2-0",
      "name": "冷却器4出口（对照表存疑）",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": false,
      "note": "冷凝；压缩机子系统未启用，可能未接或接错"
    },
    {
      "section": "温度(48)",
      "key": "T2_1",
      "hardware": "T2-1",
      "name": "液化二氧化碳出口",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": false,
      "note": "冷凝；压缩机子系统未启用，可能未接或接错"
    },
    {
      "section": "温度(48)",
      "key": "T2_2",
      "hardware": "T2-2",
      "name": "液氮进口",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": false,
      "note": "冷凝；压缩机子系统未启用，可能未接或接错"
    },
    {
      "section": "温度(48)",
      "key": "T2_3",
      "hardware": "T2-3",
      "name": "液氮出口",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": false,
      "note": "冷凝；压缩机子系统未启用，可能未接或接错"
    },
    {
      "section": "温度(48)",
      "key": "T2_4",
      "hardware": "T2-4",
      "name": "冷却器1出口",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "冷却"
    },
    {
      "section": "温度(48)",
      "key": "T2_5",
      "hardware": "T2-5",
      "name": "冷却器1进口",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "冷却"
    },
    {
      "section": "温度(48)",
      "key": "T2_6",
      "hardware": "T2-6",
      "name": "冷却器2进口",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "冷却"
    },
    {
      "section": "温度(48)",
      "key": "T2_7",
      "hardware": "T2-7",
      "name": "冷却器2出口",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "冷却"
    },
    {
      "section": "温度(48)",
      "key": "T2_8",
      "hardware": "T2-8",
      "name": "冷却器3进口",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "冷却"
    },
    {
      "section": "温度(48)",
      "key": "T2_9",
      "hardware": "T2-9",
      "name": "冷却器3出口",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "冷却"
    },
    {
      "section": "温度(48)",
      "key": "T2_10",
      "hardware": "T2-10",
      "name": "冷却器4进口",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "冷却"
    },
    {
      "section": "温度(48)",
      "key": "T2_11",
      "hardware": "T2-11",
      "name": "冷却器4出口",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "冷却"
    },
    {
      "section": "温度(48)",
      "key": "T2_12",
      "hardware": "T2-12",
      "name": "再沸器入口",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "再沸器/蒸汽"
    },
    {
      "section": "温度(48)",
      "key": "T2_13",
      "hardware": "T2-13",
      "name": "再沸器出口",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "再沸器/蒸汽"
    },
    {
      "section": "温度(48)",
      "key": "T2_14",
      "hardware": "T2-14",
      "name": "再沸器内部中部",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "再沸器内部"
    },
    {
      "section": "温度(48)",
      "key": "T2_15",
      "hardware": "T2-15",
      "name": "再沸器内部底部",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "再沸器内部"
    },
    {
      "section": "温度(48)",
      "key": "T3_0",
      "hardware": "T3-0",
      "name": "吸收塔顶 第1点",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "循环(塔顶)"
    },
    {
      "section": "温度(48)",
      "key": "T3_1",
      "hardware": "T3-1",
      "name": "吸收塔顶 第2点",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "循环(塔顶)"
    },
    {
      "section": "温度(48)",
      "key": "T3_2",
      "hardware": "T3-2",
      "name": "吸收塔顶 第3点",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "循环(塔顶)"
    },
    {
      "section": "温度(48)",
      "key": "T3_3",
      "hardware": "T3-3",
      "name": "吸收塔顶 第4点",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "循环(塔顶)"
    },
    {
      "section": "温度(48)",
      "key": "T3_4",
      "hardware": "T3-4",
      "name": "吸收塔顶 第5点",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "循环(塔顶)"
    },
    {
      "section": "温度(48)",
      "key": "T3_5",
      "hardware": "T3-5",
      "name": "解吸塔顶 第1点",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "循环(塔顶)"
    },
    {
      "section": "温度(48)",
      "key": "T3_6",
      "hardware": "T3-6",
      "name": "解吸塔顶 第2点",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "循环(塔顶)"
    },
    {
      "section": "温度(48)",
      "key": "T3_7",
      "hardware": "T3-7",
      "name": "解吸塔顶 第3点",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "循环(塔顶)"
    },
    {
      "section": "温度(48)",
      "key": "T3_8",
      "hardware": "T3-8",
      "name": "解吸塔顶 第4点",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "循环(塔顶)"
    },
    {
      "section": "温度(48)",
      "key": "T3_9",
      "hardware": "T3-9",
      "name": "解吸塔顶 第5点",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "循环(塔顶)"
    },
    {
      "section": "温度(48)",
      "key": "T3_10",
      "hardware": "T3-10",
      "name": "蒸汽冷却器 热侧进口",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "再沸器/蒸汽"
    },
    {
      "section": "温度(48)",
      "key": "T3_11",
      "hardware": "T3-11",
      "name": "蒸汽冷却器 冷侧出口",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "再沸器/蒸汽"
    },
    {
      "section": "温度(48)",
      "key": "T3_12",
      "hardware": "T3-12",
      "name": "蒸汽冷却器 冷侧入口",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "再沸器/蒸汽"
    },
    {
      "section": "温度(48)",
      "key": "T3_13",
      "hardware": "T3-13",
      "name": "蒸汽冷却器 热侧出口",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "再沸器/蒸汽"
    },
    {
      "section": "温度(48)",
      "key": "T3_14",
      "hardware": "T3-14",
      "name": "蒸汽发生器出口",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "再沸器/蒸汽；可辅助判断蒸汽发生器是否运行（启停为物理按钮，无信号入软件）"
    },
    {
      "section": "温度(48)",
      "key": "T3_15",
      "hardware": "T3-15",
      "name": "再沸器内部顶部",
      "quantity": "温度",
      "unit": "℃",
      "range": 1,
      "offset": 0,
      "decimals": 2,
      "source": "NiTemperature",
      "scale": "Linear",
      "enabled": true,
      "note": "再沸器/蒸汽"
    },
    {
      "section": "模拟量(16)",
      "key": "A4_0",
      "hardware": "A4-0",
      "name": "CO2进气流量",
      "quantity": "流量",
      "unit": "m3/h",
      "range": 10.0,
      "offset": 0.0,
      "decimals": 2,
      "source": "NiAnalog",
      "scale": "Current4To20",
      "enabled": true,
      "note": ""
    },
    {
      "section": "模拟量(16)",
      "key": "A4_1",
      "hardware": "A4-1",
      "name": "空气进气流量",
      "quantity": "流量",
      "unit": "m3/h",
      "range": 50.0,
      "offset": 0.0,
      "decimals": 2,
      "source": "NiAnalog",
      "scale": "Current4To20",
      "enabled": true,
      "note": ""
    },
    {
      "section": "模拟量(16)",
      "key": "A4_2",
      "hardware": "A4-2",
      "name": "富液泵流量",
      "quantity": "流量",
      "unit": "L/h",
      "range": 300.0,
      "offset": 0.0,
      "decimals": 1,
      "source": "NiAnalog",
      "scale": "Current4To20",
      "enabled": true,
      "note": "🔴 富液（富溶剂）流量计实测有故障，读数不可信。连带影响 Q1_H / Reheating_C / Reheating_H 三个以它为流量项的派生热负荷。面板标 0-170L/h，量程按 300 换算"
    },
    {
      "section": "模拟量(16)",
      "key": "A4_3",
      "hardware": "A4-3",
      "name": "贫液泵流量",
      "quantity": "流量",
      "unit": "L/h",
      "range": 300.0,
      "offset": 0.0,
      "decimals": 1,
      "source": "NiAnalog",
      "scale": "Current4To20",
      "enabled": true,
      "note": "面板标 0-170L/h，量程按 300 换算"
    },
    {
      "section": "模拟量(16)",
      "key": "A4_4",
      "hardware": "A4-4",
      "name": "捕集CO2输出流量",
      "quantity": "流量",
      "unit": "m3/h",
      "range": 10.0,
      "offset": 0.0,
      "decimals": 2,
      "source": "NiAnalog",
      "scale": "Current4To20",
      "enabled": true,
      "note": ""
    },
    {
      "section": "模拟量(16)",
      "key": "A4_5",
      "hardware": "A4-5",
      "name": "吸收塔气体冷凝冷却器冷却水流量",
      "quantity": "流量",
      "unit": "m3/h",
      "range": 3.0,
      "offset": 0.0,
      "decimals": 2,
      "source": "NiAnalog",
      "scale": "Current4To20",
      "enabled": true,
      "note": ""
    },
    {
      "section": "模拟量(16)",
      "key": "A4_6",
      "hardware": "A4-6",
      "name": "解吸塔气体冷凝冷却器冷却水流量",
      "quantity": "流量",
      "unit": "m3/h",
      "range": 8.0,
      "offset": 0.0,
      "decimals": 2,
      "source": "NiAnalog",
      "scale": "Current4To20",
      "enabled": true,
      "note": ""
    },
    {
      "section": "模拟量(16)",
      "key": "A4_7",
      "hardware": "A4-7",
      "name": "压缩机后冷却器冷却水流量",
      "quantity": "流量",
      "unit": "m3/h",
      "range": 3.0,
      "offset": 0.0,
      "decimals": 2,
      "source": "NiAnalog",
      "scale": "Current4To20",
      "enabled": false,
      "note": "压缩机子系统未启用，可能未接或接错"
    },
    {
      "section": "模拟量(16)",
      "key": "A4_8",
      "hardware": "A4-8",
      "name": "冷却水总流量",
      "quantity": "流量",
      "unit": "m3/h",
      "range": 15.0,
      "offset": 0.0,
      "decimals": 2,
      "source": "NiAnalog",
      "scale": "Current4To20",
      "enabled": true,
      "note": ""
    },
    {
      "section": "模拟量(16)",
      "key": "A4_9",
      "hardware": "A4-9",
      "name": "冷却器1冷水流量",
      "quantity": "流量",
      "unit": "m3/h",
      "range": 8.0,
      "offset": 0.0,
      "decimals": 2,
      "source": "NiAnalog",
      "scale": "Current4To20",
      "enabled": true,
      "note": "设备对照表里写 p-1-1 压力，已过时"
    },
    {
      "section": "模拟量(16)",
      "key": "A4_10",
      "hardware": "A4-10",
      "name": "解吸塔内压力",
      "quantity": "压力",
      "unit": "kPa",
      "range": 1000.0,
      "offset": 0.0,
      "decimals": 1,
      "source": "NiAnalog",
      "scale": "Current4To20",
      "enabled": true,
      "note": "绝压传感器，不加 101。原混合气压力通道改用途"
    },
    {
      "section": "模拟量(16)",
      "key": "A4_11",
      "hardware": "A4-11",
      "name": "吸收塔液位",
      "quantity": "液位",
      "unit": "mm",
      "range": 700.0,
      "offset": 0.0,
      "decimals": 1,
      "source": "NiAnalog",
      "scale": "Current4To20",
      "enabled": true,
      "note": "压力变送器换算。原富液泵后压力 0.4MPa 改用途。levelGauge 显示 = 值/700*100%。与 A4-12 配对用于判断两塔溶剂平衡"
    },
    {
      "section": "模拟量(16)",
      "key": "A4_12",
      "hardware": "A4-12",
      "name": "解吸塔液位",
      "quantity": "液位",
      "unit": "mm",
      "range": 700.0,
      "offset": 0.0,
      "decimals": 1,
      "source": "NiAnalog",
      "scale": "Current4To20",
      "enabled": true,
      "note": "压力变送器换算。原贫液泵后压力 0.4MPa 改用途。与 A4-11 配对用于判断两塔溶剂平衡"
    },
    {
      "section": "模拟量(16)",
      "key": "A4_13",
      "hardware": "A4-13",
      "name": "分离器液位",
      "quantity": "液位",
      "unit": "mm",
      "range": 700.0,
      "offset": 0.0,
      "decimals": 1,
      "source": "NiAnalog",
      "scale": "Current4To20",
      "enabled": true,
      "note": "压力变送器换算。原压缩机进口压力 0.4MPa 改用途。解吸塔出口气液分离器"
    },
    {
      "section": "模拟量(16)",
      "key": "A4_14",
      "hardware": "A4-14",
      "name": "压缩机出口压力",
      "quantity": "压力",
      "unit": "kPa",
      "range": 2500.0,
      "offset": 101.0,
      "decimals": 1,
      "source": "NiAnalog",
      "scale": "Current4To20",
      "enabled": false,
      "note": "相对压传感器，+101 转绝压（A4-10 是绝压传感器所以不加）。压缩机未启用，可能未接或接错"
    },
    {
      "section": "模拟量(16)",
      "key": "A4_15",
      "hardware": "A4-15",
      "name": "蒸汽流量",
      "quantity": "流量",
      "unit": "待确认",
      "range": 250.0,
      "offset": 0.0,
      "decimals": 2,
      "source": "NiAnalog",
      "scale": "Current4To20",
      "enabled": true,
      "note": "单位待实机运行确认。可辅助判断蒸汽发生器是否运行"
    },
    {
      "section": "设备状态(2)",
      "key": "dev0",
      "hardware": "串口字节31",
      "name": "设备状态字0",
      "quantity": "状态位域",
      "unit": "-",
      "range": 1.0,
      "offset": 0.0,
      "decimals": 0,
      "source": "StmDeviceState",
      "scale": "Linear",
      "enabled": true,
      "note": "bit0贫液泵 bit1富液泵 bit2鼓风机 bit3塔风机 bit4塔水泵 bit5循环水泵 bit6烟气加热 bit7蒸汽发生器(空处理，启停为物理按钮无信号)"
    },
    {
      "section": "设备状态(2)",
      "key": "dev1",
      "hardware": "串口字节32",
      "name": "设备状态字1",
      "quantity": "状态位域",
      "unit": "-",
      "range": 1.0,
      "offset": 0.0,
      "decimals": 0,
      "source": "StmDeviceState",
      "scale": "Linear",
      "enabled": true,
      "note": "bit4吸收塔回流泵 bit5解吸塔回流泵 bit6补水箱低位 bit7补水箱高位"
    },
    {
      "section": "变频频率(3)",
      "key": "freq_poor",
      "hardware": "串口字节25-26",
      "name": "贫液泵频率",
      "quantity": "频率",
      "unit": "Hz",
      "range": 0.01,
      "offset": 0.0,
      "decimals": 2,
      "source": "StmConverterFreq",
      "scale": "Linear",
      "enabled": true,
      "note": "原始值 Hz*100，乘 0.01 还原"
    },
    {
      "section": "变频频率(3)",
      "key": "freq_rich",
      "hardware": "串口字节27-28",
      "name": "富液泵频率",
      "quantity": "频率",
      "unit": "Hz",
      "range": 0.01,
      "offset": 0.0,
      "decimals": 2,
      "source": "StmConverterFreq",
      "scale": "Linear",
      "enabled": true,
      "note": "原始值 Hz*100，乘 0.01 还原"
    },
    {
      "section": "变频频率(3)",
      "key": "freq_air",
      "hardware": "串口字节29-30",
      "name": "鼓风机频率",
      "quantity": "频率",
      "unit": "Hz",
      "range": 0.01,
      "offset": 0.0,
      "decimals": 2,
      "source": "StmConverterFreq",
      "scale": "Linear",
      "enabled": true,
      "note": "原始值 Hz*100，乘 0.01 还原"
    },
    {
      "section": "电表(6)",
      "key": "m0_power",
      "hardware": "电表0",
      "name": "蒸汽发生器功率",
      "quantity": "功率",
      "unit": "W",
      "range": 1.0,
      "offset": 0.0,
      "decimals": 1,
      "source": "StmMeter",
      "scale": "Linear",
      "enabled": true,
      "note": "单位未经实机核实。启停为物理按钮，状态靠此值推断"
    },
    {
      "section": "电表(6)",
      "key": "m0_energy",
      "hardware": "电表0",
      "name": "蒸汽发生器正向电能",
      "quantity": "电能",
      "unit": "kWh",
      "range": 1.0,
      "offset": 0.0,
      "decimals": 2,
      "source": "StmMeter",
      "scale": "Linear",
      "enabled": true,
      "note": "单位未经实机核实"
    },
    {
      "section": "电表(6)",
      "key": "m1_power",
      "hardware": "电表1",
      "name": "动力设备功率",
      "quantity": "功率",
      "unit": "W",
      "range": 1.0,
      "offset": 0.0,
      "decimals": 1,
      "source": "StmMeter",
      "scale": "Linear",
      "enabled": true,
      "note": "单位未经实机核实"
    },
    {
      "section": "电表(6)",
      "key": "m1_energy",
      "hardware": "电表1",
      "name": "动力设备正向电能",
      "quantity": "电能",
      "unit": "kWh",
      "range": 1.0,
      "offset": 0.0,
      "decimals": 2,
      "source": "StmMeter",
      "scale": "Linear",
      "enabled": true,
      "note": "单位未经实机核实"
    },
    {
      "section": "电表(6)",
      "key": "m2_power",
      "hardware": "电表2",
      "name": "压缩机功率",
      "quantity": "功率",
      "unit": "W",
      "range": 1.0,
      "offset": 0.0,
      "decimals": 1,
      "source": "StmMeter",
      "scale": "Linear",
      "enabled": false,
      "note": "压缩机当前未启用，字段保留但标记为未启用"
    },
    {
      "section": "电表(6)",
      "key": "m2_energy",
      "hardware": "电表2",
      "name": "压缩机正向电能",
      "quantity": "电能",
      "unit": "kWh",
      "range": 1.0,
      "offset": 0.0,
      "decimals": 2,
      "source": "StmMeter",
      "scale": "Linear",
      "enabled": false,
      "note": "压缩机当前未启用，字段保留但标记为未启用"
    }
  ]
} as const;
